//
const siteSidebar = document.querySelector('.site-sidebar');

//
if (siteSidebar !== null) {

    //
    const details = siteSidebar.querySelectorAll('details');

    //
    const smallViewportSize = parseInt(getComputedStyle(document.querySelector(':root')).getPropertyValue('--small-viewport-width'), 10);

    //
    let isInSmallViewportMode = false;

    //
    const toggleOpenAttribute = () => {

        //moving from small to large viewport
        if (isInSmallViewportMode && window.innerWidth > smallViewportSize) {

            //force open the menus
            details.forEach((detail) => detail.setAttribute('open', 'open'));

            //
            isInSmallViewportMode = false;

        }

        //moving from large to small
        if (!isInSmallViewportMode && window.innerWidth < smallViewportSize) {

            //force all the menus to be closed
            details.forEach((detail) => detail.removeAttribute('open'));

            //
            isInSmallViewportMode = true;

        }

    };

    //
    window.addEventListener('resize', toggleOpenAttribute);
    toggleOpenAttribute();

    //close the other menus
    siteSidebar.querySelectorAll('summary.heading').forEach(summary => {
        summary.addEventListener('click', (event) => {
            if (isInSmallViewportMode && !event.target.parentElement.open) {
                details.forEach((detail) => {
                    if (detail !== event.target.parentElement) {
                        detail.removeAttribute('open');
                    }
                });
            }
        });
    });

    //close all the menu's when a click hits the body (unless it went through the sidebar)
    document.querySelector('body').addEventListener('click', (event) => {

        //
        if (!isInSmallViewportMode) {
            return;
        }

        //
        let eventTarget = event.target;

        //move up the dom tree to check if the target or any of its parents match the selector (replicating the way jquery .on() works)
        while (eventTarget) {
            if (eventTarget.matches('.site-sidebar-wrapper')) {
                event.stopPropagation();
                return;
            }
            eventTarget = eventTarget?.parentElement;
        }

        //
        details.forEach((detail) => {
            detail.removeAttribute('open');
        });

    });

    //close the menu when the user navigates to an option
    siteSidebar.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
            if (isInSmallViewportMode) {
                details.forEach((detail) => {
                    detail.removeAttribute('open');
                });
            }
        });
    });

    //
    const ScrollSpy = require('../utils/ScrollSpy');

    //
    const sidebarScrollSpy = new ScrollSpy('.site-sidebar ul li', '.container-column a[name]');
    sidebarScrollSpy.enableSmoothScroll();

}
